/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/searchContextsOverrides';

export type SearchContextsPathParams = NonNullable<operations['searchContexts']['parameters']['path']>;

export type SearchContextsQueryParams = NonNullable<operations['searchContexts']['parameters']['query']>;

export type SearchContextsRequestBody = OperationRequestBodyContent<operations['searchContexts']>;

export interface Input extends SearchContextsPathParams {
  apiVersion?: string;
  query?: SearchContextsQueryParams;
  body: SearchContextsRequestBody;
}

export async function searchContexts(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/environments/{environmentKey}/contexts/search', {
    params: { path, query },
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
